import { useEffect } from "react";

const SecurityMeasures = () => {
  useEffect(() => {
    // Disable Right-Click
    document.addEventListener("contextmenu", (event) => event.preventDefault());

    // Disable Developer Tools Shortcuts
    const handleKeyDown = (event) => {
      if (
        event.keyCode === 123 || // F12
        (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J" || event.key === "C")) || 
        (event.ctrlKey && event.key === "U") // Ctrl + U (View Source)
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Detect Open DevTools
    const detectDevTools = () => {
      const before = new Date().getTime();
      debugger; // Triggers when DevTools is open
      const after = new Date().getTime();
      if (after - before > 100) {
        alert("Developer Tools detected! Access restricted.");
        window.location.href = "/";
      }
    };

    setInterval(detectDevTools, 3000);

    // Blur Page if DevTools is Open
    const devToolsCheck = setInterval(() => {
      if (window.outerWidth - window.innerWidth > 100 || window.outerHeight - window.innerHeight > 100) {
        document.body.style.filter = "blur(10px)";
      } else {
        document.body.style.filter = "none";
      }
    }, 1000);

    return () => {
      document.removeEventListener("contextmenu", (event) => event.preventDefault());
      document.removeEventListener("keydown", handleKeyDown);
      clearInterval(devToolsCheck);
    };
  }, []);

  return null;
};

export default SecurityMeasures;
